import React, { FC, useMemo } from 'react';
import styles from './index.module.scss';
import { Skeleton, EmptyFilter } from 'src/common';
import { TenderSubCatName } from 'src/models/procurements/Tender/types';
import { ReadOnlyText, TenderCat, TenderSubCat } from 'src/shared';
import DocsSubCat from '../Documents';
import classNames from 'classnames';
import LocationSubCat from '../Location';
import ProcurementSubCat from '../Procurement';
import ContractSubCat from '../Contract';
import ContactSubCat from '../Contact';
import { useTenderFree } from 'src/models/procurements/TenderFree/hooks';
import { useTitle } from 'react-use';
import { useTranslation } from 'react-i18next';

export const TenderFreeContent: FC = () => {
  const { t } = useTranslation();
  const { data, loading, isExpired } = useTenderFree();
  const descSubCat = data?.generalCat[TenderSubCatName.ShortDescription];
  const desc = descSubCat?.description;
  const title = useMemo(() => (data?.info.name ? data.info.name : document.title), [data?.info.name]);
  useTitle(title, { restoreOnUnmount: true });

  return loading ? (
    <Skeleton active loading className={classNames(styles.loader, styles.content)} />
  ) : data ? (
    <div className={styles.content}>
      <TenderCat>
        <div className={styles.ThreeQuarters}>
          {descSubCat && desc && (
            <TenderSubCat subCat={descSubCat}>
              <ReadOnlyText string={desc} className={styles.desc} />
            </TenderSubCat>
          )}
        </div>
        <div className={styles.Quarter}>
          <LocationSubCat />
        </div>
        <ProcurementSubCat />
        <ContractSubCat />
        <ContactSubCat />
        <DocsSubCat />
      </TenderCat>
    </div>
  ) : isExpired ? (
    <EmptyFilter title={t('DetailsPage.linkExpiredTitle')} desc={t('DetailsPage.linkExpiredDesc')} />
  ) : null;
};

export default TenderFreeContent;
